import { foundationFilterBarStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroFilterBarStyles = (context, definition) => css `
  ${foundationFilterBarStyles(context, definition)}
  .toggle,
  .toggle-collapsed {
    background: var(--ag-background-color, #181d1f);
    color: #ccc;
  }

  .toggle:hover,
  .toggle-collapsed:hover {
    color: var(--ag-alpine-active-color, #2196f3);
  }
`;
